function SearchIcon({ iconStyle }) {
  return (
    <svg
      className={iconStyle}
      width='19'
      height='19'
      viewBox='0 0 19 19'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M9.10384 17.2189C4.63092 17.2189 0.989258 13.5772 0.989258 9.10433C0.989258 4.63141 4.63092 0.989746 9.10384 0.989746C13.5768 0.989746 17.2184 4.63141 17.2184 9.10433C17.2184 13.5772 13.5768 17.2189 9.10384 17.2189ZM9.10384 2.17725C5.28009 2.17725 2.17676 5.2885 2.17676 9.10433C2.17676 12.9202 5.28009 16.0314 9.10384 16.0314C12.9276 16.0314 16.0309 12.9202 16.0309 9.10433C16.0309 5.2885 12.9276 2.17725 9.10384 2.17725Z'
        fill='#5E6E88'
      />
      <path
        d='M17.4173 18.0106C17.2669 18.0106 17.1165 17.9551 16.9977 17.8364L15.4144 16.2531C15.1848 16.0235 15.1848 15.6435 15.4144 15.4139C15.644 15.1843 16.024 15.1843 16.2535 15.4139L17.8369 16.9972C18.0665 17.2268 18.0665 17.6068 17.8369 17.8364C17.7181 17.9551 17.5677 18.0106 17.4173 18.0106Z'
        fill='#5E6E88'
      />
    </svg>
  );
}

export default SearchIcon;
